<script setup lang="ts">
import Navbar from "@/components/layout/Navbar.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import Wrapper from "@/components/layout/Wrapper.vue";
import ErrorBoundary from "@/shared/components/ErrorBoundary.vue";
</script>

<template>
  <div class="flex flex-row max-h-screen">
    <Sidebar />
    <div class="flex flex-col w-full max-h-screen">
      <Wrapper>
        <Navbar />
      </Wrapper>
      <div class="lg:px-20 md:px-10 sm:px-0 max-h-screen h-full w-full overflow-y-auto">
        <ErrorBoundary>
          <router-view />
        </ErrorBoundary>
      </div>
    </div>
  </div>
</template>
